/**
 * Google Reviews Configuration
 * ============================
 *
 * This file contains curated Google reviews for display on the website.
 *
 * TO UPDATE REVIEWS:
 * 1. Visit Google Maps: https://maps.google.com/?q=Gup+Shup+Chit+Chat+Chai+Romford
 * 2. Click on "Reviews" to see all reviews
 * 3. Copy relevant reviews to this file
 * 4. Update the overallRating and totalReviews counts
 *
 * FOR AUTOMATIC UPDATES:
 * Option 1: Use Elfsight Widget (Recommended for ease)
 *   - Sign up at https://elfsight.com/google-reviews-widget/
 *   - Create a widget for your Google Business
 *   - Set ELFSIGHT_WIDGET_ID below and set USE_ELFSIGHT to true
 *
 * Option 2: Google Places API (Requires backend)
 *   - Get a Google Places API key
 *   - Set up a serverless function to fetch reviews
 *   - Update this component to fetch from your API endpoint
 */

// Configuration
export const REVIEWS_CONFIG = {
  // Set to true to use Elfsight widget instead of curated reviews
  // When true, the widget automatically pulls and updates Google reviews
  USE_ELFSIGHT: false,

  // Your Elfsight widget ID (get from elfsight.com dashboard)
  // 1. Go to https://elfsight.com/google-reviews-widget/
  // 2. Create free account and search for "Gup Shup Chit Chat Chai"
  // 3. Customize the widget appearance
  // 4. Copy the widget ID (looks like: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  // 5. Paste it below
  ELFSIGHT_WIDGET_ID: 'b0bf0e5e-226a-4128-b4cf-9a68bcda0146',

  // Google Maps URL for "Write a Review" button
  GOOGLE_MAPS_URL: 'https://www.google.com/maps/place/Gup+Shup+-+Chit+Chat+Chai/@51.5995789,0.1604545,17z/data=!4m18!1m9!3m8!1s0x47d8a38fc0c16041:0xbdc61d8cb7aa394f!2sGup+Shup+-+Chit+Chat+Chai!8m2!3d51.5995756!4d0.1630294!9m1!1b1!16s%2Fg%2F11t3fpw46m!3m7!1s0x47d8a38fc0c16041:0xbdc61d8cb7aa394f!8m2!3d51.5995756!4d0.1630294!9m1!1b1!16s%2Fg%2F11t3fpw46m?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D',

  // Google Place ID (for API integration)
  GOOGLE_PLACE_ID: 'ChIJ...' // Update with actual Place ID
};

// Overall rating data
export const GOOGLE_RATING = {
  overallRating: 4.8,
  totalReviews: '1000+',
  platform: 'Google',
  lastUpdated: '2025-01-01', // Update when you refresh reviews

  // Rating breakdown (percentage)
  breakdown: {
    5: 88,
    4: 7,
    3: 2,
    2: 1,
    1: 2
  }
};

// Curated reviews to display (Real Google Reviews)
// Add/update these periodically from Google Maps
export const CURATED_REVIEWS = [
  {
    id: 1,
    author: 'Saida Begum',
    rating: 5,
    date: '2 weeks ago',
    text: 'A very relaxed and warm atmosphere. Food is delicious and the variety is great for fussy adults and kids alike. Drinks menu is extensive and delicious. Very great local feel here to take a break if shopping or running errands. French toast was delicious and the desi breakfast hit the spot.',
    avatar: null
  },
  {
    id: 2,
    author: 'Zeeshan Mahmood',
    rating: 5,
    date: 'a month ago',
    text: '10/10 desi breakfast, the chana was perfectly spiced, puri was fluffy - well cooked and not too oily, Spanish latte smooth and delicious, paratha was amazing with alo bhujiya. A perfectly situated desi food spot with an array of options that would fit all your cravings. Comfortable seating, chill vibe and overall would highly recommend. (Toilet facility available also) The owner clearly put his love into this business.',
    avatar: null
  },
  {
    id: 3,
    author: 'nawal farooq',
    rating: 5,
    date: '2 months ago',
    text: 'Awesome place, to sit with friends / family and have brunch / breakfast. Good taste, everything is awesome. There bhelpuri, bun kebab and karak chai were awesome. They are a fusion of food from both India and Pakistan. The staff is also very good.',
    avatar: null
  },
  {
    id: 4,
    author: 'Zaynab Haque',
    rating: 5,
    date: '3 months ago',
    text: 'One of the best meals I\'ve ever had! Especially the butter chicken, the flavour was insane. The service is wonderful - Arshia was really welcoming and lovely. She gave us great recommendations and was super helpful. The lychee mojito is great and the knafa milk cake was incredible. Food came out quick and was delicious! I really recommend you try this place! Free parking outside after 5pm is a bonus too! We left very full and very happy - we will definitely be back.',
    avatar: null
  }
];
